import BaseAccordion from 'components/Accordions/BaseAccordion';
import { Button } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa6';

/** Show saved places as expandable cards using the shared editing controls. */
const SavedPlacesAccordion = ({
  rows,
  selectedPlaceId,
  editingPlaceId,
  emptyMessage,
  onSelectPlace,
  renderTitleForm,
  renderActions,
}) => (
  <div className="saved-place-cards d-flex flex-column gap-2">
    {rows.length === 0 && (
      <p className="text-center mb-0 py-3" role="status">
        {emptyMessage}
      </p>
    )}
    {rows.map(({ id, title, type, TypeIcon, location, place }) => (
      <div key={id} className="saved-place-card" data-selected={id === selectedPlaceId}>
        <BaseAccordion
          eventKey={id}
          headingLevel="h3"
          bodyBackground="var(--color-base)"
          header={
            <span className="d-flex align-items-center gap-2 min-w-0 w-100">
              <span className="user-menu-place-type-icon" aria-hidden="true">
                <TypeIcon size={20} />
              </span>
              <span className="min-w-0 flex-grow-1">
                <span className="d-block fw-semibold text-break">{title}</span>
                <span className="d-flex flex-wrap gap-2 small mt-1">
                  <span>{type}</span>
                  {place.DefaultLocationUserHome && type !== 'Home' && (
                    <span className="fw-semibold">Home</span>
                  )}
                  {id === selectedPlaceId && <span className="fw-semibold">Previewing</span>}
                </span>
              </span>
              <FaChevronDown className="saved-place-chevron flex-shrink-0" aria-hidden="true" />
            </span>
          }
        >
          <div className="d-flex flex-column gap-3">
            <div>
              <span className="d-block small fw-semibold mb-1">Location</span>
              <p className="mb-0 text-break">{location || 'No address available.'}</p>
            </div>
            {editingPlaceId === id && renderTitleForm(place)}
            <Button
              className="align-self-start"
              size="sm"
              aria-label={`Preview ${title}`}
              aria-pressed={id === selectedPlaceId}
              onClick={() => onSelectPlace(place)}
            >
              Preview
            </Button>
            {renderActions(place, true)}
          </div>
        </BaseAccordion>
      </div>
    ))}
  </div>
);

export default SavedPlacesAccordion;
